"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSCallForwardingComponent = void 0;
const ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
const account_service_1 = require("../../services/account.service");
const helper_service_1 = require("../../services/helper.service");
const _ = require("underscore");
const searchfilter_pipe_1 = require("../../pipes/searchfilter.pipe");
const roles_helper_service_1 = require("../../services/roles-helper.service");
const constants_1 = require("../../constants");
class CSCallForwardingComponent {
    constructor(accountDetailService, helperService, modalService, rolesService) {
        this.accountDetailService = accountDetailService;
        this.helperService = helperService;
        this.modalService = modalService;
        this.rolesService = rolesService;
        this.editUpdate = false;
        this.sortFilterArray = ['1-10', '20 lines', '50 lines', '100 lines'];
        this.callSortNumber = '1-10';
        this.pager = {};
        this.showDetails = true;
        this.currentIndex = 0;
        this.isAdding = false;
        this.isRemoving = false;
        this.isExpanded = false;
        this.currentActivePage = 0;
        this.roles = constants_1.UserRole;
    }
    ngOnInit() {
        this.callSortNumber = '1-10';
        this.onSelectSort(this.callSortNumber);
    }
    ngOnChanges() {
        var _a, _b, _c;
        if (this.subList) {
            this.subList = (_a = this.subList) === null || _a === void 0 ? void 0 : _a.filter(function (subscription) {
                var _a;
                if (((_a = subscription === null || subscription === void 0 ? void 0 : subscription.plan) === null || _a === void 0 ? void 0 : _a.planName) !== 'WEARABLE_DPPONLY') {
                    return subscription;
                }
            });
        }
        if (this.isPrimary || (this.businessAccount && this.showRoles([this.roles.ACCOUNT_PRIMARY, this.roles.IT_SUPPORT]))) {
            this.filteredSubscriptions = _.clone(this.subList);
            this.showSearchbox = ((_b = this.filteredSubscriptions) === null || _b === void 0 ? void 0 : _b.length) > 10;
        }
        else {
            this.filteredSubscriptions = _.where(this.subList, { 'mobileNumber': this.mobileNumber });
        }
        this.hasSubsForCallForwarding = ((_c = this.filteredSubscriptions) === null || _c === void 0 ? void 0 : _c.length) > 0;
    }
    getCallForwardingInfo() {
        this.loader = true;
        this.accountDetailService.getCallForwardingInfo(this.selectedSubscriptionId).subscribe((accountInfo) => {
            this.callForwardInfo = accountInfo;
            this.loader = false;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    setPage(page, pageSize) {
        if (this.currentActivePage !== page && this.isExpanded) {
            this.resetStatusOnPageChange();
            this.currentActivePage = page;
        }
        if (this.pager.totalPages !== 0) {
            if (page < 1 || page > this.pager.totalPages) {
                return;
            }
        }
        if (pageSize === '1-10') {
            pageSize = 10;
        }
        else if (pageSize === '20 lines') {
            pageSize = 20;
        }
        else if (pageSize === '50 lines') {
            pageSize = 50;
        }
        else if (pageSize === '100 lines') {
            pageSize = 100;
        }
        // get pager object from service
        if (this.filteredSubscriptions && page !== undefined) {
            this.pager = this.helperService.getPager(this.filteredSubscriptions.length, page, pageSize);
            this.startIndex = this.pager.startIndex;
            this.endIndex = this.pager.endIndex + 1;
            this.currentActivePage = page;
        }
    }
    onSelectSort(selectNumber) {
        this.setPage(1, selectNumber);
        if (selectNumber === '1-10') {
            this.sortNumber = 10;
        }
        else if (selectNumber === '20 lines') {
            this.sortNumber = 20;
        }
        else if (selectNumber === '50 lines') {
            this.sortNumber = 50;
        }
        else if (selectNumber === '100 lines') {
            this.sortNumber = 100;
        }
        this.setPage(this.pager.currentPage, this.sortNumber);
    }
    addCallForwardingInfo(user) {
        this.loader = true;
        this.resetAddRemoveStatus();
        if (user) {
            this.accountDetailService.addCallForwardingInfo(user.mobileNumber, user.forwardedMobileNumber).subscribe((res) => {
                if (res) {
                    this.callStatus = res ? 'PASS' : 'FAIL';
                    this.getCallForwardingInfo();
                }
                else {
                    this.callStatus = 'FAIL';
                }
                this.isAdding = true;
                this.successMDN = user.mobileNumber;
                this.loader = false;
            }, (err) => {
                this.error = err;
                this.loader = false;
            });
        }
    }
    removeCallForwardingInfo(user) {
        this.loader = true;
        this.resetAddRemoveStatus();
        if (user) {
            this.accountDetailService.removeCallForwardingInfo(user.mobileNumber).subscribe((res) => {
                if (res) {
                    this.removeStatus = res ? 'PASS' : 'FAIL';
                    this.getCallForwardingInfo();
                }
                else {
                    this.callStatus = 'FAIL';
                }
                this.isRemoving = true;
                this.successMDN = user.mobileNumber;
                this.loader = false;
            }, (err) => {
                this.error = err;
                this.loader = false;
            });
        }
    }
    formatMobile(event) {
        if (event.currentTarget.value !== '') {
            event.currentTarget.value = event.currentTarget.value.replace(/\(|\)|-| /g, '');
            if (event.currentTarget.value.length > 10) {
                event.currentTarget.value = event.currentTarget.value.substring(0, 10);
            }
            event.currentTarget.value = event.currentTarget.value.replace(/^(\d{3})(\d{3})(\d{4})+$/, '$1-$2-$3');
        }
    }
    inputOnlyNumber(event) {
        return (event.charCode === 8 || event.charCode === 0) ? null : event.charCode >= 48 && event.charCode <= 57;
    }
    toggleStatus(subId, index) {
        this.currentIndex = index;
        this.callStatus = '';
        this.resetAddRemoveStatus();
        if (this.selectedSubscriptionId === subId) {
            this.showDetails = !this.showDetails;
            this.isExpanded = !this.isExpanded;
        }
        else {
            this.selectedSubscriptionId = subId;
            this.showDetails = true;
            this.isExpanded = true;
            this.getCallForwardingInfo();
        }
    }
    onInputSearchChange(searchText) {
        var _a;
        const searchPipe = new searchfilter_pipe_1.SearchFilterPipe();
        const searchTextWithoutDashes = this.sanitizePhoneNumber(searchText);
        this.filteredSubscriptions = searchPipe.transform(this.subList, { 'mobileNumber': searchTextWithoutDashes, 'subscriberBusinessName': searchText, 'esnMeid': searchText, 'modelNumber': searchText, 'isSearchData': true }, false);
        this.callSortNumber = '1-10';
        this.onSelectSort(this.callSortNumber);
        if (((_a = this.filteredSubscriptions) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            const index = this.filteredSubscriptions.findIndex((sub) => sub.subscriptionId === this.selectedSubscriptionId);
            this.currentIndex = index;
        }
        this.searchQuery = searchText;
    }
    sanitizePhoneNumber(phoneNumber) {
        // Remove dashes from the phone number
        return phoneNumber.replace(/-/g, '');
    }
    showRoles(roles) {
        return this.rolesService.getRolesPermission(roles);
    }
    resetAddRemoveStatus() {
        this.isAdding = false;
        this.isRemoving = false;
    }
    resetStatusOnPageChange() {
        this.resetAddRemoveStatus();
        this.isExpanded = false;
        this.showDetails = false;
        this.selectedSubscriptionId = null;
    }
}
exports.CSCallForwardingComponent = CSCallForwardingComponent;
//# sourceMappingURL=callforwarding.component.js.map